export const OPERATION_LOCATION_HEADER = 'X-Location-Id';

/**
 * Контекст Apollo-операции записи другой локации: её заголовок вместо локации вкладки.
 * `queryDeduplication: false` обязателен — Apollo склеивает одновременные запросы по тексту и
 * переменным без учёта заголовков, и запрос без аргумента локации для двух локаций получил бы один ответ.
 */
export function operationLocationContext(locationId: string | null | undefined): {
  headers?: Record<string, string>;
  queryDeduplication?: false;
} {
  return locationId ? { headers: { [OPERATION_LOCATION_HEADER]: locationId }, queryDeduplication: false } : {};
}
